import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const TestLanguageDropdown = ({ isMobile = false }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  if (isMobile) {
    return (
      <div className="space-y-2">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full text-left text-white hover:text-white/80 transition-colors py-2 flex items-center justify-between"
          data-testid="mobile-test-dropdown"
        >
          <span>Test Your Level</span>
          <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
        </button>
        {isOpen && (
          <div className="pl-4 space-y-2" data-testid="mobile-test-menu">
            <button
              onClick={() => handleNavigate('/french-level-test')}
              className="block w-full text-left text-white/90 hover:text-white transition-colors py-2 text-sm"
            >
              French
            </button>
            <button
              onClick={() => handleNavigate('/english-level-test')}
              className="block w-full text-left text-white/90 hover:text-white transition-colors py-2 text-sm"
            >
              English
            </button>
            <button
              onClick={() => handleNavigate('/spanish-level-test')}
              className="block w-full text-left text-white/90 hover:text-white transition-colors py-2 text-sm"
            >
              Spanish
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className="relative group"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      data-testid="desktop-test-dropdown"
    >
      <button
        className="text-white hover:text-white/80 transition-colors flex items-center gap-1"
        style={{ textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8)' }}
      >
        Test Your Level
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div
          className="absolute top-full left-0 pt-2"
          data-testid="desktop-test-menu"
        >
          <div className="bg-white rounded-lg shadow-xl py-2 min-w-[160px]">
            <button
              onClick={() => handleNavigate('/french-level-test')}
              className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-[#04539F] hover:text-white transition-colors"
            >
              French
            </button>
            <button
              onClick={() => handleNavigate('/english-level-test')}
              className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-[#04539F] hover:text-white transition-colors"
            >
              English
            </button>
            <button
              onClick={() => handleNavigate('/spanish-level-test')}
              className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-[#04539F] hover:text-white transition-colors"
            >
              Spanish
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestLanguageDropdown;